/* eslint-disable prefer-const */




export const useModuControleStore = defineStore("moduControleStore", () => {
	let acondicionamentoAutomatico = ref<"S" | "N">("N");



	return {
		acondicionamentoAutomatico
	}
})